import { deserialize, serialize } from "cerialize";
import EntityAware from "../EntityAware";

export default class TUKAllowedItem implements EntityAware {
    @serialize
    @deserialize
    public id: number = 0;

    @serialize
    @deserialize
    public nama: string = "";
}
